<div class="flex items-center justify-center h-[80vh]">
  <div class="flex flex-col items-center">
    <img src="assets/images/EscrowTabLogo.svg" class="w-auto h-32" />

    @if (complete) {
      <p class="pt-6 text-2xl font-medium text-center text-midnight">
        Your password has been set.
      </p>
      <button
        type="button"
        (click)="goToLogin()"
        class="mt-6 capitalize rounded-full w-44 btn btn-xl btn-primary"
      >
        Back to login
      </button>
    } @else {
      @if (invalidToken) {
        <p
          class="pt-6 text-2xl font-medium text-center text-red-600"
          role="alert"
        >
          This setup link is invalid or has expired.
        </p>
        <p class="pt-2 text-center text-midnight">
          Ask your administrator to send a new invite.
        </p>
      } @else {
        <p class="pt-6 text-4xl font-bold text-center text-midnight">
          Set your password
        </p>
        <p class="pt-2 pb-6 text-xl font-medium text-center text-midnight">
          Welcome to EscrowTab. Choose a password to activate your account.
        </p>
        <form
          class="flex flex-col mt-6"
          [formGroup]="form"
          (ngSubmit)="setPassword(form.value.newPassword)"
        >
          <et-atoms-input>
            <label class="!bg-base-100">Password</label>
            <input
              class="!bg-transparent !w-96"
              etAtomsInput
              formControlName="newPassword"
              type="password"
              autocomplete="new-password"
            />
            @if (
              form.get('newPassword')?.touched &&
              form.get('newPassword')?.hasError('isOffline')
            ) {
              <span etAtomsInputError>Please, try again when online</span>
            }
            @if (
              form.get('newPassword')?.touched &&
              form.get('newPassword')?.hasError('required')
            ) {
              <span etAtomsInputError>Enter a password</span>
            }
            @if (
              form.get('newPassword')?.touched &&
              form.get('newPassword')?.hasError('minlength')
            ) {
              <span etAtomsInputError
                >Password must be at least
                {{ minPasswordLength }} characters</span
              >
            }
            @if (
              !form.get('newPassword')?.touched ||
              (!form.get('newPassword')?.hasError('minlength') &&
                !form.get('newPassword')?.hasError('required') &&
                !form.get('newPassword')?.hasError('isOffline'))
            ) {
              <span class="block mt-1 text-sm text-midnight/70"
                >Must be at least {{ minPasswordLength }} characters</span
              >
            }
          </et-atoms-input>
          <et-atoms-input class="mt-4">
            <label class="!bg-base-100">Confirm password</label>
            <input
              class="!bg-transparent !w-96"
              etAtomsInput
              formControlName="confirmPassword"
              type="password"
              autocomplete="new-password"
            />
            @if (
              form.get('confirmPassword')?.touched &&
              form.get('confirmPassword')?.hasError('required')
            ) {
              <span etAtomsInputError>Confirm your password</span>
            }
            @if (
              form.get('confirmPassword')?.touched &&
              !form.get('confirmPassword')?.hasError('required') &&
              form.hasError('passwordMismatch')
            ) {
              <span etAtomsInputError>Passwords don&apos;t match</span>
            }
          </et-atoms-input>
          <div class="flex justify-center mt-4">
            <button
              type="submit"
              [disabled]="form.invalid || submitted"
              class="self-center capitalize rounded-full w-44 btn btn-xl btn-primary"
            >
              Set password
            </button>
            @if (submitted) {
              <et-atoms-spinner
                class="absolute mt-1 text-center ml-[250px]"
              ></et-atoms-spinner>
            }
          </div>
        </form>
      }
    }
  </div>
</div>
